export default __webpack_public_path__ + "static/media/stripe.b76f9b2f.png";